/* eslint-disable max-len */
import store from '@/store';
import { storage } from '@/helpers';

const apiUrl = process.env.VUE_APP_ROSSTAT_API_URL;

export default {
  data() {
    return {
      data: null,
      refreshTimer: null,
      modalData: [],
      showModal: false,
      typeModal: '',
      lastRestartedDate: null,
      requestObj: {
        month: '02',
        status: 'all',
        year: '2022',
        type: '',
        source: '',
        informationType: '',
      },
    };
  },

  async mounted() {
    this.requestObj.type = this.variablesType[0]?.value || '';
    await this.requestData();
    this.refreshTimer = setInterval(() => {
      this.requestData();
    }, 5000);
  },

  beforeDestroy() {
    clearInterval(this.refreshTimer);
  },

  computed: {
    config() {
      return store.state.activeSidebarItem;
    },
    exportName() {
      const type = this.selectedType?.name;
      return `${this.title}${type ? `_${type}` : ''}`;
    },
    title() {
      return this.config === undefined
        ? ''
        : this.config?.customprops.table.title || store.state.activeSidebarItem?.title || '';
    },
    translate_dict() {
      return this.config === undefined ? [] : this.config?.customprops?.translate_dict || [];
    },
    pageId() {
      return this.$route.params.type;
    },
    date_filtres() {
      return this.config === undefined ? false : this.config?.customprops.date_filtres || false;
    },
    selectedType() {
      return this.variablesType.find((el) => el.value === this.requestObj.type);
    },
    actions() {
      return this.config?.customprops?.actions !== false;
    },
    defaultDate() {
      return this.selectedType?.defaultDate;
    },
    variablesType() {
      return this.config === undefined ? [] : this.config?.customprops.variablesType || [];
    },
    tableHeader() {
      const defHeader = [
        { name: '', tag: '', id: 1 },
        { name: 'Дата', tag: 'date', id: 2 },
        { name: 'Название', tag: 'name', id: 3 },
        { name: 'Статус', tag: 'status', id: 4 },
        { name: 'Начало посл. загрузки', tag: 'date1', id: 5 },
        { name: 'Окончание посл. загрузки', tag: 'date2', id: 6 },
        { name: 'Информация о загрузке', tag: 'info', id: 7 },
        { name: 'Действия', tag: 'action', id: 8 },
      ];
      return this.config === undefined
        ? defHeader
        : this.config?.customprops.table?.columns || defHeader;
    },
  },

  watch: {
    pageId() {
      this.data = null;
      this.requestData();
    },
    requestObj() {
      this.requestData();
    },
  },

  methods: {
    openModal(type, obj) {
      this.typeModal = type;
      this.showModal = true;
      this.modalData = [];
      if (obj) {
        Object.keys(obj).forEach((key) => {
          this.modalData.push({ name: key, value: obj[key] });
        });
      }
    },
    async clickRestart(obj) {
      let run_config = {};
      let pipeline = '';
      if (store.state.activeSidebarItem.code === 'learning_history') {
        pipeline = 'complex_pipeline';
        run_config = {
          solids: {
            get_config_for_job: {
              config: {
                category: obj.mainCategory,
              },
            },
          },
        };
      } else {
        pipeline = this.selectedType?.pipeline;
        if (obj.name.split('|')[0] === 'fns_download') pipeline = 'rosstat_fns_ftp_pipeline';
        this.lastRestartedDate = obj.key_restart || obj.mainDate || obj.date;
        if (
          this.requestObj.type === 'annual_processing_history' ||
          this.requestObj.type === 'regular_processing_history_index'
        ) {
          run_config = {
            solids: {
              get_configs: {
                config: {
                  job_name: obj.name.split('|')[0],
                  processing_date: obj.key_restart || obj.mainDate || obj.date,
                },
              },
            },
          };
        } else if (this.requestObj.type === 'identification_processing_history') {
          run_config = {
            solids: {
              get_configs: {
                config: {
                  job_name: obj.name.split('|')[0],
                  processing_date: obj.key_restart || obj.mainDate || obj.date,
                },
              },
            },
          };
        } else if (this.requestObj.type === 'primary_data_download') {
          run_config = {
            solids: {
              solid_fns_download: {
                config: {
                  period: obj.mainDate,
                  source: 'fns',
                },
              },
            },
          };
        }
      }
      if (pipeline && run_config) {
        await this.axios
          .post(
            `${apiUrl}/worker/start_job`,
            {
              pipeline,
              run_config,
              mode: 'default',
            },
            {
              headers: {
                'finch-auth': `Bearer ${storage.get('authToken')}`,
                fio: encodeURIComponent(store.state.userFio),
                region: encodeURIComponent(store.state.regionName),
              },
            },
          )
          .then((res) => {
            const result = res.data.data?.launchPipelineExecution;
            if (result?.__typename === 'LaunchPipelineRunSuccess') {
              this.$notification.success({
                message: 'Запрос на перезапуск процесса отправлен',
              });
            } else {
              this.$notification.error({
                message: `Не удалось отправить запрос на перезапуск процесса. Обратитесь к администратору.`,
              });
            }
          })
          .catch(() => {
            this.$notification.error({
              message: `Не удалось отправить запрос на перезапуск процесса. Обратитесь к администратору.`,
            });
          });
      }
    },
    async clickStop(obj) {
      await this.axios
        .post(
          `${apiUrl}/worker/stop_job?date_processing=${obj.mainDate}&job_name=${obj.name}&index=${this.requestObj.type}&username=${store.state.user.username}&runId=${obj.runId}&pid=${obj.pid}`,
          {
            headers: {
              'finch-auth': `Bearer ${storage.get('authToken')}`,
              fio: encodeURIComponent(store.state.userFio),
              region: encodeURIComponent(store.state.regionName),
            },
          },
        )
        .then(() => {
          this.$notification.success({
            message: 'Запрос на остановку процесса отправлен.',
          });
        })
        .catch(() => {
          this.$notification.error({
            message: `Не удалось отправить запрос на остановку процесса. Обратитесь к администратору.`,
          });
        });
    },
    async requestFilterData(obj) {
      this.requestObj = {
        month: obj.month,
        status: obj.status,
        year: obj.year,
        type: obj.type,
      };
      const { data } = await this.axios.get(
        `${apiUrl}/worker/get_jobs_v3?year=${obj.year}&month=${obj.month}&status=${obj.status}`,
        // {
        //   headers: {
        //     'finch-auth': `Bearer ${storage.get('authToken')}`
        //   }
        // }
      );

      data.forEach((el) => {
        el.items.forEach((item) => {
          item.mainDate = el.date;
        });
      });

      this.data = data;
    },
    async requestData(obj = null) {
      if (this.date_filtres) {
        if (obj) {
          this.requestObj = {
            month: obj.month,
            status: obj.status,
            year: obj.year,
            type: obj.type,
            source: obj.type === 'primary_data_download' ? obj.source : undefined,
          };
        }
        await this.axios
          .get(
            `${apiUrl}/worker/get_jobs_v3?type_job=${this.requestObj.type}&year=${
              this.requestObj.year
            }&month=${this.requestObj.month}&status=${this.requestObj.status}&source=${
              this.requestObj.type === 'primary_data_download' ? this.requestObj.source : undefined
            }`,
            // {
            //   headers: {
            //     'finch-auth': `Bearer ${storage.get('authToken')}`
            //   }
            // }
          )
          .then(({ data }) => {
            data.forEach((el) => {
              el.any_running = false;
              el.items.forEach((item) => {
                item.translate_name = item.name
                  .split('|')
                  .map((name_el) => {
                    if (name_el === 'external_media_download') {
                      item.disabled = true;
                    }
                    return name_el in this.translate_dict ? this.translate_dict[name_el] : name_el;
                  })
                  .join(' ');
                item.date1 = item.date1 === 0 ? null : item.date1;
                item.mainDate = el.date;
                if (item.status === 'running') {
                  el.any_running = true;
                }
              });
              if (el.any_running || el.date === this.lastRestartedDate) {
                el.items.forEach((item) => {
                  item.any_running = true;
                });
              }
              el.items = el.items.sort((a, b) => this.sortingArray(a, b, 'date1'));
            });
            data = data.sort((a, b) => this.sortingArray(a, b, 'date'));
            this.data = data;
          })
          .catch((err) => {
            console.log(err);
            this.data = [];
          });
      } else if (this.config?.customprops?.source) {
        const source = this.config?.customprops?.source;
        await this.axios
          .get(`${apiUrl}${source}`, {
            // headers: {
            //   'finch-auth': `Bearer ${storage.get('authToken')}`
            // }
          })
          .then(({ data }) => {
            data.forEach((el) => {
              el.items.forEach((item) => {
                item.translate_name = item.name
                  .split('|')
                  .map((name_el) => {
                    return name_el in this.translate_dict ? this.translate_dict[name_el] : name_el;
                  })
                  .join(' ');
                item.date1 = item.date1 === 0 ? null : item.date1;
                item.mainDate = el.date;
                item.mainCategory = el.category;
              });
              el.items = el.items.sort((a, b) => this.sortingArray(a, b, 'version'));
            });
            data = data.sort((a, b) => this.sortingArray(a, b, 'category'));
            this.data = data;
          })
          .catch(() => {
            this.data = [];
          });
      }
    },
    sortingArray(a, b, key) {
      if (a[key] > b[key]) {
        return 1;
      }
      if (a[key] < b[key]) {
        return -1;
      }
      return 0;
    },
  },
};
